import { useCallback } from "react"
import { useMutation } from "react-relay"
import {
  Ch_createCallCaseSummaryFeedbackInput,
  chCreateCallCaseSummaryFeedbackMutation as chCreateCallCaseSummaryFeedbackMutationType,
} from "@/modules/patients/detail/progress-note/services/ch/__generated__/chCreateCallCaseSummaryFeedbackMutation.graphql"
import { chCreateCallCaseSummaryFeedbackMutation } from "@/modules/patients/detail/progress-note/services/ch/chCreateCallCaseSummaryFeedbackMutation"
import { deCreateCallCaseSummaryFeedbackMutation as deCreateCallCaseSummaryFeedbackMutationType } from "@/modules/patients/detail/progress-note/services/de/__generated__/deCreateCallCaseSummaryFeedbackMutation.graphql"
import { deCreateCallCaseSummaryFeedbackMutation } from "@/modules/patients/detail/progress-note/services/de/deCreateCallCaseSummaryFeedbackMutation"
import { Country } from "@/types/__generated__/union-types"

type CreateCallCaseSummaryFeedbackMutation =
  | chCreateCallCaseSummaryFeedbackMutationType
  | deCreateCallCaseSummaryFeedbackMutationType

export const useCreateCallCaseSummaryFeedbackMutation = (
  country: Country,
): [
  (input: Ch_createCallCaseSummaryFeedbackInput, onCompleted?: () => void, onError?: () => void) => void,
  boolean,
] => {
  const mutation = country === "CH" ? chCreateCallCaseSummaryFeedbackMutation : deCreateCallCaseSummaryFeedbackMutation
  const [commit, isInFlight] = useMutation<CreateCallCaseSummaryFeedbackMutation>(mutation)

  const submit = useCallback(
    (input: Ch_createCallCaseSummaryFeedbackInput, onCompleted?: () => void, onError?: () => void) => {
      commit({
        variables: { input },
        onCompleted: () => {
          onCompleted?.()
        },
        onError: () => {
          onError?.()
        },
      })
    },
    [commit],
  )

  return [submit, isInFlight]
}
